"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./_internal/utils");
function delay(wait, value) {
    return new Promise(function (resolve, reject) {
        if ((0, utils_1.isPromise)(value)) {
            value.catch(reject);
        }
        setTimeout(function () {
            resolve(value);
        }, wait);
    });
}
exports.default = delay;
//# sourceMappingURL=delay.js.map